import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { MoovInstanceData, IssueData, IssueFullData, MoovData, SubjectData } from './challenges-data';
import { AbstractChallengesService } from './challenges.abstract.service';

@Injectable({
  providedIn: 'root'
})

export class ChallengesService implements AbstractChallengesService {
  private allIssuesUrl = `${APIS.challenges}/allIssues`;
  private getIssueUrl = `${APIS.challenges}/getIssue`;
  private allSubjectsUrl = `${APIS.challenges}/allSubjects`;
  private issueForUserUrl = `${APIS.challenges}/issueForUser`;
  private moovsForUserUrl = `${APIS.challenges}/moovsForUser`;
  private moovsForSelfUrl = `${APIS.challenges}/moovsForSelf`;
  private activeMoovsForUserCounterpartUrl = `${APIS.challenges}/activeMoovsForUserCounterpart`;
  private activeMoovsForUserUrl = `${APIS.challenges}/activeMoovsForUser`;
  private pastMoovsForUserCounterpartUrl = `${APIS.challenges}/pastMoovsForUserCounterpart`;
  private pastMoovsForMoovsCounterpartUrl = `${APIS.challenges}/pastMoovsToMoovAndCounterpart`;
  private moovDetailsForCounterpartUrl = `${APIS.challenges}/moovDetailsForCounterpart`;
  private activateMoovUrl = `${APIS.challenges}/activateMoov`;
  private endMoovUrl = `${APIS.challenges}/endMoov`;
  private addUserEventToMoovUrl = `${APIS.challenges}/addUserEventToMoov`;
  private topRecommendedMoovsUrl = `${APIS.challenges}/topRecommendedMoovs`
  private extendMoovUrl = `${APIS.challenges}/extendActiveMoov`;
  private addUserCommentToStepUrl = `${APIS.challenges}/addUserCommentToStep`;
  private setStepAsDoneUrl = `${APIS.challenges}/setStepAsDone`;
  private setStepAsPendingUrl = `${APIS.challenges}/setStepAsPending`;


  constructor(private http: HttpClient) { }
  
  getallIssues (counterpartId:string): Observable<IssueData[]> {
    return this.http.get<IssueData[]>(`${this.allIssuesUrl}?counterpartId=${counterpartId}`);
  }

  getIssue (issueId:string): Observable<IssueData> {
    return this.http.get<IssueData>(`${this.getIssueUrl}?issueId=${issueId}`);
  }

  getallSubjects (): Observable<IssueData[]> {
    return this.http.get<SubjectData[]>(`${this.allSubjectsUrl}`);
  }

  getIssuePerUser (userId: string, issueId: string): Observable<IssueFullData> {
    return this.http.get<IssueFullData>(`${this.issueForUserUrl}?userId=${userId}&issueId=${issueId}`);
  } 

  getMoovsPerIssueAndCounterpart (counterpartId: string, issueId: string, motivationId= ""): Observable<MoovData[]>{
    return this.http.get<MoovData[]>(`${this.moovsForUserUrl}?userId=${counterpartId}&issueId=${issueId}&motivationId=${motivationId}`);
  }

  getmoovsForSelf (issueId: string, motivationId= ""): Observable<MoovData[]>{
    return this.http.get<MoovData[]>(`${this.moovsForSelfUrl}?issueId=${issueId}&motivationId=${motivationId}`);
  }
  
  getActiveMoovsForUserCounterpart (counterpartId: string): Observable<MoovInstanceData[]>{
    return this.http.get<MoovInstanceData[]>(`${this.activeMoovsForUserCounterpartUrl}?counterpartId=${counterpartId}`);
  }

  getActiveMoovsForUser (): Observable<MoovInstanceData[]>{
    return this.http.get<MoovInstanceData[]>(`${this.activeMoovsForUserUrl}`);
  }

  getPastMoovsForUserCounterpart (counterpartId: string): Observable<MoovInstanceData[]>{
    return this.http.get<MoovInstanceData[]>(`${this.pastMoovsForUserCounterpartUrl}?counterpartId=${counterpartId}`);
  }

  getMoovDetailsForCounterpart (moovId: string, counterpartId: string): Observable<MoovData>{
    return this.http.get<MoovData>(`${this.moovDetailsForCounterpartUrl}?moovId=${moovId}&counterpartId=${counterpartId}`);
  }

  getPastMoovsforMoovAndCounterpart (counterpartId: string, moovId: string): Observable<MoovInstanceData[]>{
    return this.http.get<MoovInstanceData[]>(`${this.pastMoovsForMoovsCounterpartUrl}?counterpartId=${counterpartId}&moovId=${moovId}`);
  }

  activateMoov (moovId:string, counterpartId: string, isMoovForSelf: boolean = false): Observable<MoovInstanceData>{
    let isMoovForSelfParam : string = '0';
    if (isMoovForSelf){
      isMoovForSelfParam = '1';
    }
    return this.http.get<MoovInstanceData>(`${this.activateMoovUrl}?moovId=${moovId}&counterpartId=${counterpartId}&isMoovForSelf=${isMoovForSelfParam}`);
  }

  endMoov (moovId:string, feedbackScore: number, feedbackText: string): Observable<string>{
    return this.http.post<string>(this.endMoovUrl, { moovId: moovId, feedbackScore: feedbackScore, feedbackText:feedbackText }, {});
    // return this.http.get<string>(`${this.endMoovUrl}?moovId=${moovId}&feedbackScore=${feedbackScore}&feedbackText=${feedbackText}`);
  }

  getTopRecommendedMoovs (counterpartId: string): Observable<MoovData[]>{
    // console.log(`in challenges service calling ${this.topRecommendedMoovsUrl}?userId=${userId}&counterpartId=${counterpartId}`)
    return this.http.get<MoovData[]>(`${this.topRecommendedMoovsUrl}?counterpartId=${counterpartId}`);
  }

  extendActiveMoov (activeMoovId:string): Observable<MoovInstanceData>{
    // console.log(`in challenges service calling ${this.extendMoovUrl}?activeMoovId=${activeMoovId}`);
    return this.http.get<MoovInstanceData>(`${this.extendMoovUrl}?activeMoovId=${activeMoovId}`);
  }

  addUserEventToMoov (moovId:string, userText: string): Observable<MoovInstanceData>{
    return this.http.post<MoovInstanceData>(this.addUserEventToMoovUrl, { moovId: moovId, userText:userText }, {});
  }

  addUserCommentToStep (activeMoovId:string, stepId:string, userText: string): Observable<MoovInstanceData>{
    return this.http.post<MoovInstanceData>(this.addUserCommentToStepUrl, { activeMoovId: activeMoovId, stepId: stepId, userText:userText }, {});
  }

  setStepAsDone (activeMoovId:string, stepId: string): Observable<MoovInstanceData>{
    return this.http.post<MoovInstanceData>(this.setStepAsDoneUrl, { activeMoovId: activeMoovId, stepId:stepId }, {});
  }

  setStepAsPending (activeMoovId:string, stepId: string): Observable<MoovInstanceData>{
    return this.http.post<MoovInstanceData>(this.setStepAsPendingUrl, { activeMoovId: activeMoovId, stepId:stepId }, {});
  }
}